import React, {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Typography} from 'antd'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {Icon, Tabs} from '@/components'
import styles from './styles.scss'
import {PaymentLinkQr} from '../PaymentLinkQr'
import {NewPaymentLinkWidgetPreviewProps} from './props'
import {linkWebPreview, linkMobilePreview} from '@/pages/PayByLink/constants/previews'
import {PLATFORM_LAPTOP, PLATFORM_MOBILE, QR} from '@/constants/playwright-ids'

const {Title, Text} = Typography

export const NewPaymentLinkWidgetPreview = observer(
    ({url = '', isDetails = false}: NewPaymentLinkWidgetPreviewProps) => {
        const [type, setType] = useState<'mobile' | 'laptop' | 'qr'>(isDetails ? 'qr' : 'laptop')
        const {t} = useTranslation()

        const tabs = useMemo(
            () =>
                [
                    {title: <Icon type='qr' data-test-id={QR} />, key: 'qr', visible: isDetails},
                    {
                        title: <Icon type='laptop' data-test-id={PLATFORM_LAPTOP} />,
                        key: 'laptop',
                        visible: true
                    },
                    {
                        title: <Icon type='mobile' data-test-id={PLATFORM_MOBILE} />,
                        key: 'mobile',
                        visible: true
                    }
                ]
                    .filter((t) => t.visible)
                    .map(({visible, ...t}) => t),
            [isDetails]
        )

        return (
            <>
                <Title level={4}>{t('NewPaymentLinkWidgetPreview.widgetPreview')}</Title>
                <Text>{t('NewPaymentLinkWidgetPreview.thisIsHowYourClient')}</Text>

                {isDetails && type === 'qr' && <PaymentLinkQr url={url} />}

                {type === 'laptop' && (
                    <img
                        className={styles.previewImageLaptop}
                        src={linkWebPreview}
                        alt='link preview'
                    />
                )}
                {type === 'mobile' && (
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <img
                            className={styles.previewImageMobile}
                            src={linkMobilePreview}
                            alt='link preview'
                            width={192}
                            height={192}
                        />
                    </div>
                )}
                <Tabs className={styles.tabs} tabs={tabs} onChange={(t) => setType(t as any)} />
            </>
        )
    }
)
